import React, { Component } from 'react';
import ServiceIcons  from './ServiceIcons';

import { connect } from 'react-redux';

class JurisServices extends Component {

    render() {
    
        return (

            <section className="juris-services light-bg row" id="services">
                <div className="container">
                        
                    <div className="row juris-section-title xs-text-center">
                        <div className="col-xs-12 col-sm-5 col-md-4 text-center">

                            <div className="title-container">
                                <h2> {this.props.title} </h2>
                            </div>

                        </div>

                        <div className="col-xs-12 col-sm-7 col-md-5">
                            <p> { this.props.subtitle } </p>
                        </div>
                    </div>

                    <div className="row juris-services-list">

                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="service-icon-container text-center">
                                <ServiceIcons.Family />
                                <h4 dangerouslySetInnerHTML={this.props.family} />
                            </div>
                        </div>

                    
                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="service-icon-container text-center">
                                <ServiceIcons.Civil />
                                <h4 dangerouslySetInnerHTML={this.props.civil} />
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="service-icon-container text-center">
                                <ServiceIcons.Housing />
                                <h4 dangerouslySetInnerHTML={this.props.housing} />
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="service-icon-container text-center">
                                <ServiceIcons.Municipal />
                                <h4 dangerouslySetInnerHTML={this.props.municipal} /> 
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="service-icon-container text-center">
                                <ServiceIcons.Penal />
                                <h4 dangerouslySetInnerHTML={this.props.penal} />
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="service-icon-container text-center">
                                <ServiceIcons.Immigration />
                                <h4 dangerouslySetInnerHTML={this.props.immigration} /> 
                                
                            </div>
                        </div>
                    
                    </div>

                </div>
            </section>
        )


    }

}


const mapStateToProps = ({currentLocale, dictionaries}) => {
    return {
        title : dictionaries[currentLocale]["services"]["title"],
        subtitle : dictionaries[currentLocale]["services"]["subtitle"],
        family : { __html: dictionaries[currentLocale]["services"]["family"] },
        civil : { __html: dictionaries[currentLocale]["services"]["civil"] },
        housing : { __html: dictionaries[currentLocale]["services"]["housing"] },
        municipal : { __html: dictionaries[currentLocale]["services"]["municipal"] },
        penal : { __html: dictionaries[currentLocale]["services"]["penal"] },
        immigration : { __html: dictionaries[currentLocale]["services"]["immigration"] },

    }
}

export default connect(mapStateToProps)(JurisServices);


/** WEBPACK FOOTER **
 ** ./src/components/JurisServices.jsx
 **/